import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  error: null,
  loading: false,

  temporaryContainerInfo: {
    id: '',
    container: '',
    posterPath: '',
    title: '',
    load: 10,
    height: '750',
    length: '4500',
    size: '7.6',
    sizesLadle: [],
  },

  quantity: 0,
  cartItems: [],
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,

  reducers: {
    addToCart: (state, { payload }) => {
      const checkProduct = state.cartItems.find(item => item.id === payload.id);
      if (!checkProduct) {
        state.cartItems = [...state.cartItems, { ...payload, quantity: 1 }];
      } else {
        state.cartItems = state.cartItems.map(item => {
          if (item.id === payload.id) {
            return { ...item, quantity: item.quantity + 1 };
          } else {
            return item;
          }
        });
      }
      state.quantity++;
    },

    removeFromCart: (state, { payload }) => {
      state.cartItems = state.cartItems.filter(item => item.id !== payload.id);
      state.quantity -= payload.quantity;
    },

    increment: (state, { payload }) => {
      state.cartItems = state.cartItems.map(item => {
        if (item.id === payload) {
          return { ...item, quantity: item.quantity + 1 };
        } else {
          return item;
        }
      });
      state.quantity++;
    },

    decrement: (state, { payload }) => {
      const cartItem = state.cartItems.find(item => item.id === payload);
      if (cartItem.quantity === 1) {
        state.cartItems = state.cartItems.filter(
          item => item.id !== cartItem.id
        );
      } else {
        cartItem.quantity -= 1;
      }
      state.quantity--;
    },
    clearCart: state => {
      state.cartItems = [];
      state.quantity = 0;
    },
    updateID: (state, { payload }) => {
      state.temporaryContainerInfo.id = payload;
    },
    updateLoad: (state, { payload }) => {
      state.temporaryContainerInfo.load = payload;
    },
    updateSizes: (state, { payload }) => {
      state.temporaryContainerInfo.length = payload.length;
      state.temporaryContainerInfo.height = payload.height;
      state.temporaryContainerInfo.size = payload.size;
    },
    updateSizesLadle: (state, { payload }) => {
      state.temporaryContainerInfo.size = payload.size;
      state.temporaryContainerInfo.sizesLadle = payload.values;
    },
    updateContainerStartInfo: (state, { payload }) => {
      state.temporaryContainerInfo.id = payload.id;
      state.temporaryContainerInfo.container = payload.container;
      state.temporaryContainerInfo.title = payload.title;
      state.temporaryContainerInfo.posterPath = payload.posterPath;
    },
  },
});

export const {
  addToCart,
  removeFromCart,
  increment,
  decrement,
  clearCart,
  updateID,
  updateLoad,
  updateSizes,
  updateSizesLadle,
  updateContainerStartInfo,
} = cartSlice.actions;

export default cartSlice.reducer;
